var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M7.786 2.119c-.894 0-1.62.725-1.62 1.62v6.475c0 .894.726 1.62 1.62 1.62h6.476c.894 0 1.619-.726 1.619-1.62V3.738c0-.894-.725-1.619-1.62-1.619H7.787zm5.666 11.333v.81a3.238 3.238 0 0 1-3.238 3.238H3.738A3.238 3.238 0 0 1 .5 14.262V7.786a3.238 3.238 0 0 1 3.238-3.238h.81v-.81A3.238 3.238 0 0 1 7.786.5h6.476A3.238 3.238 0 0 1 17.5 3.738v6.476a3.238 3.238 0 0 1-3.238 3.238h-.81zm-1.619 0H7.786a3.238 3.238 0 0 1-3.238-3.238V6.167h-.81c-.894 0-1.619.725-1.619 1.619v6.476c0 .894.725 1.619 1.62 1.619h6.475c.894 0 1.62-.725 1.62-1.62v-.809z", id: "svg3515885474a" })
    ),
    React.createElement(
      "g",
      { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "svg3515885474b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#svg3515885474a" })
      ),
      React.createElement("use", { fillRule: "nonzero", xlinkHref: "#svg3515885474a" }),
      React.createElement(
        "g",
        { mask: "url(#svg3515885474b)", fill: "currentColor" },
        React.createElement("path", { d: "M-1-1h20v20H-1z" })
      )
    )
  );
});